import * as React from 'react'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { IOption, IProviderProps } from '@user/components/Filters'
import { selectSalespersonFilterOptions } from '@user/store/map'

// Feeds MultiSelectAutoComplete from Redux instead of Formik (per Functional
// Design Question 1) — modeled directly on OwnerProvider.tsx's render-prop shape.
export function SalespersonFilterProvider({ render }: IProviderProps) {
  const salespersonFilterOptions = useSelector(selectSalespersonFilterOptions)

  const options = useMemo(() => {
    const toOption =
      (group?: string) =>
      (o: (typeof salespersonFilterOptions)[number]): IOption => ({
        value: o.userId,
        label: o.name,
        group,
      })
    const regular = salespersonFilterOptions
      .filter((o) => !o.isAdmin)
      .map(toOption(undefined))
    const admins = salespersonFilterOptions
      .filter((o) => o.isAdmin)
      .map(toOption('Admins'))
    return [...regular, ...admins]
  }, [salespersonFilterOptions])

  return <>{render(options, false, true)}</>
}
